import React from 'react'
import students from '../../../../images/main/students.jpg'
import vector_right from '../../../../images/basic/header/vector_right.svg'

import styles from './styles.module.scss'
import {Link} from 'react-router-dom'
import parse from 'html-react-parser'

const TeachWithGenerium = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.wr1}>
        <div className={styles.left}>
          <p className={styles.title}>Возможности для студентов</p>
        </div>
        <div className={styles.right}>
          <p className={styles.title}>Учитесь новому <br/> с Generium</p>
        </div>
      </div>
      <div className={styles.wr2}>
        <div className={styles.left}>
          <img src={students} alt='students' draggable='false'/>
        </div>
        <div className={styles.right}>
          <div className={styles.desc}>
            <div className={styles.preview}>
              <p className={styles.text}>
                Generium — отличное место для старта карьеры. Мы активно развиваем молодых специалистов, продвигаем
                наставничество и корпоративное обучение.
              </p>
              <p className={styles.text}>
                У нас есть собственные образовательные программы и стажировки по разнообразным направлениям в R&D и на производстве.
              </p>
            </div>
            <div className={styles.down}>
              <div className={styles.down_wrapper}>
                <div className={styles.down_wrapper_desc}>
                  <p className={styles.down_wrapper_p1}>Образование с Generium</p>
                  <p className={styles.down_wrapper_p2}>Программы высшего образования совместно с МГУ имени М. В.
                    Ломоносова и РТУ МИРЭА</p>
                </div>
                <Link to='/students/education' className={styles.button}>
                  Узнать больше
                  <img className={styles.vector_right} src={vector_right} alt='vector' draggable='false'/>
                </Link>
              </div>
              <div className={styles.down_wrapper}>
                <div className={styles.down_wrapper_desc}>
                  <p className={styles.down_wrapper_p1}>Стажировки</p>
                  <p className={styles.down_wrapper_p2}>Возможность получить реальный опыт до окончания вуза</p>
                </div>
                <Link to='/students/internShips' className={styles.button}>
                  Узнать больше
                  <img className={styles.vector_right} src={vector_right} alt='vector' draggable='false'/>
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.img}>
            <img src={students} alt='students' draggable='false'/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeachWithGenerium
